'use client';

import { Button, ButtonGroup } from "@heroui/button";
import { useRouter } from 'next/navigation';

enum Period {
  Day = 'day',
  Week = 'week',
  Month = 'month'
};

type PopularPeriodSelectProps = {
  selected: string;
}

const PeriodLabels = {
  [Period.Day]: 'Сьогодні',
  [Period.Week]: 'За тиждень',
  [Period.Month]: 'За місяць'
}

export const PopularPeriodSelect = ({ selected }: PopularPeriodSelectProps) => {
  const router = useRouter();


  const onChange = (period: string) => {
    router.push(`/popular/${period}`);
  }

  return (
    <ButtonGroup>
      {Object.values(Period).map(period => {
        return (
          <Button
            key={period}
            color={selected === period ? 'primary' : 'default'}
            onClick={() => onChange(period)}
          >
            {PeriodLabels[period]}
          </Button>
        )
      })}
    </ButtonGroup>
  )
}